import { render, staticRenderFns } from "./assignPosition.vue?vue&type=template&id=54863a7f"
import script from "./assignPosition.vue?vue&type=script&lang=js"
export * from "./assignPosition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports